import { Component, OnInit } from '@angular/core';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';

@Component({
  selector: 'app-page-maintenance',
  templateUrl: './page-maintenance.component.html',
  styleUrls: ['./page-maintenance.component.css']
})
export class PageMaintenanceComponent implements OnInit {

  constructor(
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit() {
  }

  get maintenanceWebshopText(): string {
    return this.shopSettingsService.maintenanceWebshopText;
  }

  get maintenanceMessage() {
    return this.shopSettingsService.isVUMode ? 'Communication problem. Please try again later or contact your administrator' : '';
  }
}
